import {
  CONCEPT_LOAD,
  CONCEPT_LOAD_SUCCESS,
  CONCEPT_ERROR,
  CONCEPT_SAVE,
  CONCEPT_SAVE_SUCCESS,
  CONCEPT_CLEAN,
  CONCEPT_DELETE,
  CONCEPT_DELETE_SUCCESS
} from "./actionTypes"

export const conceptError = error => {
  return {
    type: CONCEPT_ERROR,
    payload: error,
  }
}
export const initLoadConcepts = (state) => {
  return {
    type: CONCEPT_LOAD,
    payload: state,
  }
}
export const initDeleteConcepts = (list) => {
  return {
    type: CONCEPT_DELETE,
    payload: list,
  }
}
export const deleteConcept = response => {
  return {
    type: CONCEPT_DELETE_SUCCESS,
    payload: { response },
  }
}
export const loadConcepts = concepts => {
  concepts.forEach(c => {
    c.label = c.name
    c.value = c.code
  })
  return {
    type: CONCEPT_LOAD_SUCCESS,
    payload: concepts,
  }
}
export const saveConcept = concept => {
  return {
    type: CONCEPT_SAVE,
    payload: { concept },
  }
}
export const saveConceptSuccess = response => {
  return {
    type: CONCEPT_SAVE_SUCCESS,
    payload: { response },
  }
}
export const cleanConcept = () => {
  return {
    type: CONCEPT_CLEAN,
    payload: {},
  }
}
